import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iframer',
  templateUrl: './iframer.component.html',
  styleUrls: ['./iframer.component.scss']
})
export class IframerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
